// Instagram Feed
const carouselInsta = document.getElementById("carousel-i");
const iLoadingText = document.getElementById("i-loading-text");
let instaToken;
carouselInsta.style.visibility = "hidden";
async function getInstagramToken() {
  try {
    const response = await fetch(
      "https://shopify.josenaranjo.dev/api/v1/tokens/gelato-instagram-feed"
    );
    const data = await response.json();
    console.log(data);
    if (data.status === "success") {
      instaToken = data.data.accessToken;
      //console.log(instaToken);
      if (carouselInsta) {
        // Configure Intersection Observer
        const options = {
          root: null,
          rootMargin: "0px",
          threshold: 0.1, // Lower threshold for earlier trigger
        };

        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              instagramFeedRequest();
              // Stop observing
              observer.unobserve(entry.target);
            }
          });
        }, options);

        observer.observe(carouselInsta);
      }
    } else {
      console.error("Error:", data.message);
    }
  } catch (error) {
    console.error("Fetch error:", error.message);
  }
}
getInstagramToken();

function runFlickity() {
  // Initialize Flickity after DOM updates
  const flkty = new Flickity(carouselInsta, {
    cellAlign: "left",
    contain: true,
    imagesLoaded: true,
    //percentPosition: false, // disables Flickity's internal height/positioning
    setGallerySize: false, // prevents Flickity from forcing a gallery height
    pageDots: false,
  });
}
function instagramFeedRequest() {
  console.log("Running insta feed request!");
  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        const data = JSON.parse(this.responseText).data;
        data.forEach((item) => {
          if (item.media_url !== undefined) {
            const isVideo =
              item.media_url.includes(".mp4") ||
              item.media_url.startsWith("https://video") ||
              item.media_url.includes("fna.fbcdn");
            const a = document.createElement("a");
            a.classList.add("carousel-cell");
            a.href = "https://www.instagram.com/gelatopique_usa/";
            a.target = "_blank";

            if (isVideo) {
              const video = document.createElement("video");
              const source = document.createElement("source");
              video.muted = true;
              video.loop = true;
              video.playsInline = true;
              video.autoplay = true;
              video.classList.add("insta-vid");
              source.src = item.media_url;
              source.type = "video/mp4";
              video.appendChild(source);
              a.appendChild(video);
            } else {
              const img = document.createElement("img");
              img.src = item.media_url;
              img.alt = "Gelato Pique Instagram";
              img.height = "260px";
              a.appendChild(img);
            }
            carouselInsta.appendChild(a);
          }
        });

        // Wait for all media to load
        const mediaPromises = Array.from(
          carouselInsta.querySelectorAll("img, video")
        ).map((el) => {
          return new Promise((resolve) => {
            if (el.tagName === "IMG") {
              el.onload = () => resolve();
              el.onerror = () => resolve();
            } else if (el.tagName === "VIDEO") {
              el.onloadeddata = () => resolve();
              el.onerror = () => resolve();
            }
          });
        });

        Promise.all(mediaPromises).then(() => {
          document.getElementById("insta-loader").classList.add("hidden");
          iLoadingText.style.display = "none";
          carouselInsta.style.visibility = "visible";
          runFlickity();
        });
      } else {
        console.log("Error - Bad Request!");
        iLoadingText.style.display = "none";
        carouselInsta.style.display = "none";
        document.getElementById("insta-loader").classList.add("hidden");
      }
    }
  };
  xhttp.open(
    "GET",
    `https://graph.instagram.com/v23.0/17841406369474733/media?fields=id,media_url,media_type,children{media_url,media_type,media}&access_token=${instaToken}`,
    true
  );
  xhttp.send();
}
